import React, { Component } from 'react';


class NotesCategoriesDisplay extends Component {

    constructor(props) {

        super(props);
        this.state = {
            loading: true,
            data: [],
            debug_message: null,
        };

    }

    componentDidMount() {
        this.setState(
            {},
            () => { }
        );

    }

    componentDidUpdate(prevProps) {
        if (typeof (this.props.data) !== 'undefined' && this.state.loading) {
            this.setState(
                {
                    loading: this.props.data.loading,
                    data: this.props.data.data,
                    debug_message: this.props.data.debug_message,
                },
                () => { }
            );
        }
    }

    render() {

        return (
            <>
                <select name={this.props.name} key={this.props.value} value={this.props.value} className="notesFormSelect form-control" onChange={this.props.onChange}>
                    <option value="0">Item to Add</option>
                    {this.state.data.filter(row => row.ID !== 3 && row.ID !== 42 && row.ID !== 10 && row.ID !== 4 && row.ID !== 27 && row.ID !== 44).map(row => {
                        if (row.unique) {
                            const index = this.props.noteData.findIndex(item => item.typeID === row.ID);
                            if (index === -1) {
                                return (
                                    <option key={row.ID} value={row.ID}>{row.type}</option>
                                )
                            }
                        } else {
                            return (
                                <option key={row.ID} value={row.ID}>{row.type}</option>
                            )
                        }
                        return <></>
                    })}
                </select>
            </>
        );
    };
}

export default NotesCategoriesDisplay;
